import styled from 'styled-components';

const Body = styled.div`
  padding: 30px 10px 10px;
  border-radius: 10px;
`;

export default Body;
